import Amount from "@/models/Shared/Amount";
import TransactionType from "@/models/Accounts/Shared/Transactions/TransactionType";
import DebitCreditCode from "@/models//Shared/DebitCreditCode";

export default class AdjustmentRequest {
    accountId: string;
    walletId: string;
    amount: Amount = new Amount();
    reference: string = '';
    debitCreditCode: DebitCreditCode;
    transactionType: TransactionType;
}
